import { useEffect, useState } from 'react';

export const useMonitorMicAndCameraPermissions = () => {
  const [cameraDenied, setCameraDenied] = useState(false);
  const [micDenied, setMicDenied] = useState(false);

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        const cameraPerm = await navigator.permissions.query({
          name: 'camera' as PermissionName,
        });
        const micPerm = await navigator.permissions.query({
          name: 'microphone' as PermissionName,
        });

        const handleChange = () => {
          setCameraDenied(cameraPerm.state === 'denied');
          setMicDenied(micPerm.state === 'denied');
        };

        cameraPerm.addEventListener('change', handleChange);
        micPerm.addEventListener('change', handleChange);

        handleChange();

        return () => {
          cameraPerm.removeEventListener('change', handleChange);
          micPerm.removeEventListener('change', handleChange);
        };
      } catch (error) {
        console.error('Permission API not supported', error);
      }
    };

    checkPermissions();
  }, []);

  return { cameraDenied, micDenied };
};
